export const SEND_RATE_CONFIGS_SUCCESS = 'SEND_RATE_CONFIGS_SUCCESS';
export const SEND_RATE_CONFIGS_REQUEST = 'SEND_RATE_CONFIGS_REQUEST';
export const SEND_RATE_CONFIGS_FAILURE = 'SEND_RATE_CONFIGS_FAILURE';
export const SEND_RATE_CONFIGS_REST = 'SEND_RATE_CONFIGS_REST';
export const sendRateConfigsSuccess = (payload) => ({
    type: SEND_RATE_CONFIGS_SUCCESS,
    payload,
});
export const sendRateConfigsRequest = (payload) => ({
    type: SEND_RATE_CONFIGS_REQUEST,
    payload,
});
export const sendRateConfigsFailure = (payload) => ({
    type: SEND_RATE_CONFIGS_FAILURE,
    payload,
});
export const sendRateConfigsRest = () => ({
    type: SEND_RATE_CONFIGS_REST,
});
